module.exports = __webpack_public_path__ + "assets/retina_TrByIncircleBasesDetailed.095dcf0d80d286124707c8c584829b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TrByIncircleBasesDetailed.png
// module id = 742
// module chunks = 0